module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_banco_tokyo_sipat_03.182d43db.jpg";